const safeJSONParse = (raw) => {
  let out = {};
  try {
    out = JSON.parse(raw);
  } catch (e) {}
  return out;
};

export default safeJSONParse;
